import React from 'react';
import styled  from 'styled-components';
import Win from '../datasets/futures';

const StyledComp = styled.div`
position: relative;
width: 100%;
height: 100%;
overflow: hidden;
display: flex;
flex-direction: row;
>section{
  width: 100%;
  border: none;
}

`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <Win/>
    </StyledComp>
  );
};

export default Comp;
